module.exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


//# sourceMappingURL=nb-NO.main.js.map
